import { render } from "./GridTabActivitati.vue?vue&type=template&id=b1fde23e&scoped=true&ts=true"
import script from "./GridTabActivitati.vue?vue&type=script&lang=ts"
export * from "./GridTabActivitati.vue?vue&type=script&lang=ts"

import "./GridTabActivitati.vue?vue&type=style&index=0&id=b1fde23e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1fde23e"]])

export default __exports__